export default __webpack_public_path__ + "static/media/b5.7c9a19bd.webp";